import React, { useState, useCallback } from "react";
import { Async } from "react-select";
import axios from "../../axios";
import * as url from "../../utils/url";
import debounce from "lodash/debounce";
import { Badge } from "reactstrap";
import { contvertHTMLToPlain } from "../../utils/constants";
import moment from "moment";
import { getTriviaFileName } from "../../pages/trivia/data";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px solid #ccc",
    padding: 10,
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#333",
  }),
};

const BadgeOption = ({ data }) => (
  <div>
    sss {data.label}
    {data.badge && (
      <span
        style={{
          marginLeft: 10,
          padding: "3px 6px",
          backgroundColor: "#f0f0f0",
          borderRadius: 4,
        }}
      >
        {data.badge}
      </span>
    )}
  </div>
);

const TrivvyNavbarSearchComponent = ({ user, ...props }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [maxTextScore, setTextScore] = useState(null);
  // this.timer=null;
  const [debouncedValue, setDebouncedValue] = useState(inputValue);
  const debouncedSetDebouncedValue = useCallback(
    debounce(setDebouncedValue, 1000),
    []
  );
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = async (inputValue) => {
    if (inputValue) {
      try {
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      // setSelected(null)
    }
  };

  const debounceAutoSaveData = useCallback(
    debounce(handleInputChange, 500),
    []
  );

  console.log("selected", selected);

  const renderFieldOptions = (option) => {
    return (
      <div>
        {option.label}
        {/* <Badge color="warning">{option.badge} </Badge> */}
      </div>
    );
  };

  const getNormalizedTextScore = (score, maxScore) => {
    console.log(score, "<--- score -- and max --->", maxScore);
    let norm_score = score / maxScore;
    console.log("norm -- ", norm_score);
    let percent_score = norm_score * 100;
    return percent_score;
    // ((x.textScore/maxTextScore)*100).toFixed(2)
  };

  // const getOptionsDelay = async(inputValue) => {
  //   clearTimeout(this.timer);
  //   this.timer = setTimeout(() => {
  //     this.getOptions(value);
  //   }, 1000);
  // }

  const getOptions = async (inputValue, callback) => {
    if (inputValue) {
      axios
        .get(`${url.trivvyKeywordSearch}?search=${inputValue}`)
        .then(({ data }) => {
          let surveys = data.data.surveys;
          let getMaxScore =
            surveys && surveys.length > 0 ? surveys[0].textScore : null;
          // console.log('maxScore == ', getMaxScore)

          // let highTextScore = getMaxScore

          // console.log(highTextScore,'-----surveys === ', surveys)

          const searchedList = [...data.data.surveys].map((x) => ({
            label: x.matchedQuestion
              ? `${
                  contvertHTMLToPlain(x.matchedQuestion).length > 60
                    ? `${contvertHTMLToPlain(x.matchedQuestion).slice(
                        0,
                        60
                      )}...`
                    : contvertHTMLToPlain(x.matchedQuestion)
                } 
                (${x.name}) (${moment(x.createdOn).format("MMM D, YYYY")}) `
              : x.name + ` (${moment(x.createdOn).format("MMM D, YYYY")})`,
            value: x._id,
            badge: "Trivvy",
          }));

          const librarysList = [...data.data.librarys].map((x) => ({
            label: `${getTriviaFileName({
              uploadUrl: x.s3Url,
              uploadedFileName: x.fileUploadName,
              librarySourceType: x.librarySourceType,
              libName: x.name,
            })}(Library)`,
            value: x._id,
            badge: "Library",
          }));

          let optionsArr = [];
          if (user.role === "Admin") {
            optionsArr = [...librarysList, ...searchedList];
          } else {
            optionsArr = [...searchedList];
          }
          // +`(${ getNormalizedTextScore(x.textScore, highTextScore) })`
          setOptions(optionsArr);
          // setTextScore(getMaxScore)
          callback(null, { options: optionsArr });
        })
        .catch((err) => {
          console.log(err);
          callback(err);
        });
    } else {
      callback([]);
    }
  };

  const debouncedLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      getOptions(inputValue, callback);
    }, 1000),
    []
  );

  return (
    <Async
      name="form-field-name"
      placeholder="Search by Trivvy"
      loadOptions={debouncedLoadOptions}
      // loadOptions={setInputValue()}
      filterOptions={(options, filter, currentValues) => {
        // Do no filtering, just return all options
        return options;
      }}
      onChange={(selectedOption) => {
        if (selectedOption && selectedOption.badge == "Trivvy") {
          setSelected(selectedOption);
          if (user.role == "Admin") {
            props.history.push(
              `/home/trivia/${user.organizationId._id}/edit/${selectedOption.value}/edit`
            );
          } else {
            props.history.push(
              `/home/trivia/${user.organizationId._id}/quiz/${selectedOption.value}/start`
            );
          }
        } else if(selectedOption && selectedOption.badge=="Library"){
          props.history.push(
            `/home/trivia/${user.organizationId._id}/library-item/${selectedOption.value}/view/trivvys`
          );
        } else {
          setSelected(null);
        }
      }}
    />
  );
};

export default TrivvyNavbarSearchComponent;
